import React from "react";
import { useNavigate } from "react-router-dom";
import "./MobileHeader.css";

const MobileHeader = ({ currentUser, onOpenMenu }) => {
  const navigate = useNavigate();

  const thumbnail = currentUser?.thumbnail
    ? currentUser.thumbnail.startsWith("http")
      ? currentUser.thumbnail
      : `${process.env.REACT_APP_API_URL}/${currentUser.thumbnail}`
    : "/images/default-thumbnail.jpg";

  return (
    <header className="mobile-header">
      <button
        type="button"
        className="mobile-header-profile"
        onClick={onOpenMenu}
        aria-label="Open account menu"
      >
        <img
          src={thumbnail}
          alt=""
          onError={(event) => {
            event.currentTarget.onerror = null;
            event.currentTarget.src = "/images/default-thumbnail.jpg";
          }}
        />
      </button>

      <button
        type="button"
        className="mobile-header-logo"
        onClick={() => navigate("/")}
        aria-label="Go to Home"
      >
        <img src="/images/scoldy-header-icon.png" alt="Scoldy" />
      </button>

      <button
        type="button"
        className="mobile-header-search"
        onClick={() => {
          const input =
            document.querySelector(".home-search-box") ||
            document.querySelector(".notifications-search-box") ||
            document.querySelector(".profile-search-box") ||
            document.querySelector(".settings-search-box") ||
            document.querySelector(".cloud9-search-box") ||
            document.querySelector(".search-box");

          if (input) {
            input.focus();
            input.select?.();
          }
        }}
        aria-label="Search"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="11" cy="11" r="7" />
          <path d="m16.5 16.5 4 4" />
        </svg>
      </button>
    </header>
  );
};

export default MobileHeader;
